<div class="dialog-container">

  <!-- En-tête -->
  <div class="dialog-header">
    <div class="header-title">
      <mat-icon class="header-icon">receipt_long</mat-icon>
      <div>
        <h2>Facturation des locations</h2>
        <span class="header-subtitle">
          @if (rows.length > 0) {
            {{ selectedCount }} sur {{ rows.length }} contrat{{ rows.length > 1 ? 's' : '' }} éligible{{ rows.length > 1 ? 's' : '' }}@if (excludedCount > 0) { &bull; {{ excludedCount }} ligne{{ excludedCount > 1 ? 's' : '' }} décochée{{ excludedCount > 1 ? 's' : '' }}} &bull; {{ money(totalEligibleAmount) }}&nbsp;€@if (asOf) { &bull; jusqu'au {{ day(asOf) }}}
          } @else {
            Aucun contrat éligible à facturer@if (asOf) { jusqu'au {{ day(asOf) }}}
          }
        </span>
      </div>
    </div>
    @if (!isProcessing) {
      <button mat-icon-button (click)="hasStarted ? onClose() : onCancel()" aria-label="Fermer">
        <mat-icon>close</mat-icon>
      </button>
    }
  </div>

  <!-- « Facturer jusqu'au » : jour du calcul de l'aperçu et du passage (as_of) ; un jour passé ne laisse partir que ce qui était dû ce jour-là. -->
  @if (!hasStarted && untilEnabled) {
    <div class="until-bar">
      <span class="until-label">Facturer jusqu'au</span>
      <div class="until-date">
        <app-select-date [date]="untilDate" (dateChange)="onUntilChange($event)"></app-select-date>
      </div>
      <button mat-stroked-button type="button" class="until-btn" [disabled]="!lastBilledDay || untilLoading || untilDay === lastBilledDay" (click)="untilLastBilled()"
        [matTooltip]="lastBilledTip" matTooltipClass="tooltip-multiline">
        <mat-icon>event_available</mat-icon>
        <span>@if (lastBilledDay) {Déjà facturé jusqu'au {{ day(lastBilledDay) }}@if (billedDaysDiffer) { (le plus tardif)}} @else {Rien de facturé}</span>
      </button>
      @if (asOf) {
        <button mat-stroked-button type="button" class="until-btn" [disabled]="untilLoading" (click)="untilToday()">
          <mat-icon>today</mat-icon>
          <span>Aujourd'hui</span>
        </button>
      }
      @if (untilLoading) {
        <mat-progress-spinner diameter="16" strokeWidth="2.5" mode="indeterminate"></mat-progress-spinner>
      }
      @if (untilError) {
        <span class="until-error">{{ untilError }}</span>
      } @else if (asOf) {
        <span class="until-hint">Rien n'est facturé après le {{ day(asOf) }} ; les avoirs des périodes déjà facturées partent.</span>
      }
    </div>
  }

  <!-- Aperçu refait au clic et différent de celui affiché (#33) : rien n'est parti, la liste est relue. -->
  @if (!hasStarted && staleMessage) {
    <div class="preview-notice stale-notice">
      <mat-icon class="preview-notice-icon">sync_problem</mat-icon>
      <span>{{ staleMessage }}</span>
    </div>
  }

  <!-- Étape 1 : Bandeau informatif avant confirmation -->
  @if (!hasStarted && rows.length > 0) {
    <div class="preview-notice">
      <mat-icon class="preview-notice-icon">visibility</mat-icon>
      <span>Vérifiez la liste des contrats éligibles ci-dessous avant de confirmer la facturation.</span>
    </div>
  }

  <!-- Étape 2 : Barre de progression pendant ou après traitement -->
  @if (hasStarted && totalCount > 0) {
    <div class="progress-section">
      <div class="progress-info">
        <span class="progress-label">
          @if (isProcessing) {
            Sécurisation et facturation en cours ({{ processedCount }}&nbsp;/&nbsp;{{ totalCount }})...
          } @else if (isFinished) {
            Traitement terminé : {{ successCount }} réussi{{ successCount > 1 ? 's' : '' }}@if (upToDateCount > 0) {, {{ upToDateCount }} déjà à jour (aucune pièce)}@if (errorCount > 0) {, {{ errorCount }} en échec}
          }
        </span>
        <span class="progress-percent">{{ progressPercent }}%</span>
      </div>
      <mat-progress-bar
        [mode]="isProcessing || isFinished ? 'determinate' : 'indeterminate'"
        [value]="progressPercent"
        [color]="errorCount > 0 && isFinished ? 'warn' : 'primary'">
      </mat-progress-bar>
    </div>
  }

  <!-- Contenu défilant : Tableau des contrats éligibles -->
  <div class="dialog-body">
    <!-- Bilan du passage : pièces créées par le serveur (factures et avoirs) et anomalies, avec un lien vers chaque pièce. -->
    @if (passage) {
      <div class="passage-report">
        <div class="passage-title">Pièces créées par le passage</div>
        @for (row of rows; track row.contract.order_id) {
          @let p = passageOf(row.contract.order_id);
          @if (p.invoices.length || p.credits.length || p.anomalies.length) {
            <div class="passage-order">
              <span class="passage-order-id">#{{ row.contract.order_id }} · {{ row.contract.customer_name }}</span>
              <span class="passage-docs">
                @for (i of p.invoices; track i.invoice_order_id) {
                  @let who = invoicePatients(row);
                  @if (i.fse_id) {
                    <span class="passage-doc">Facture FSE {{ docRef(i.invoice_doc_ref, i.invoice_order_id) }} (FSE n° {{ i.fse_id }})</span>
                  } @else {
                    <a class="passage-doc" [routerLink]="['/sales/quotation', i.invoice_order_id]" (click)="followDoc($event)">Facture {{ docRef(i.invoice_doc_ref, i.invoice_order_id) }}</a>
                  }
                  @if (who.text) { <span class="passage-who" [attr.title]="who.title">· {{ who.text }}</span> }
                }
                @for (c of p.credits; track c.credit_order_id) {
                  <span class="passage-doc is-credit">
                    <a [routerLink]="['/sales/quotation', c.credit_order_id]" (click)="followDoc($event)">Avoir {{ docRef(c.credit_doc_ref, c.credit_order_id) }}</a>
                    sur {{ correctsRef(row.contract, c.corrects_invoice_id) }}
                    @let cwho = creditPatients(row, c.corrects_invoice_id);
                    @if (cwho.text) { <span class="passage-who" [attr.title]="cwho.title">· {{ cwho.text }}</span> }
                  </span>
                }
              </span>
              @if (p.anomalies.length) {
                <ul class="anomaly-list">
                  @for (a of p.anomalies; track $index) {
                    <li class="anomaly-item" [class.is-blocking]="a.blocked">
                      <mat-icon class="anomaly-icon">{{ a.blocked ? 'block' : 'warning' }}</mat-icon>
                      <span class="anomaly-line">{{ anomalyLine(row.contract, a) }}{{ a.blocked ? ' · bloquée, non facturée' : '' }}</span>
                      <span class="anomaly-msg">{{ a.message }}</span>
                    </li>
                  }
                </ul>
              }
            </div>
          }
        }
        @if (passageIsEmpty) {
          <div class="passage-empty">Le serveur n'a créé aucune pièce.</div>
        }
      </div>
    }

    @if (rows.length > 0) {
      <div class="table-container">
        <table class="invoicing-table">
          <thead>
            <tr>
              <th class="col-expand"></th>
              <th class="col-checkbox">
                <mat-checkbox
                  [checked]="isAllSelected"
                  [indeterminate]="isPartiallySelected"
                  [disabled]="hasStarted"
                  (change)="toggleSelectAll($event)">
                </mat-checkbox>
              </th>
              <th class="col-id">Contrat</th>
              <th class="col-customer">Client</th>
              <th class="col-period">Période / Détail</th>
              <th class="col-amount">Montant TTC</th>
              <th class="col-type">Type</th>
              <th class="col-status">Statut</th>
            </tr>
          </thead>
          <tbody>
            @for (row of rows; track row.contract.order_id) {
              @let displayItems = getDisplayItems(row.contract);
              <tr class="row-item"
                [ngClass]="'status-' + row.status.toLowerCase()"
                [class.row-unselected]="!row.selected"
                [class.row-expanded]="row.expanded"
                [class.has-lines]="!row.expanded && displayItems.length > 0"
                (click)="toggleExpandRow(row)">
                <td class="col-expand" (click)="$event.stopPropagation()">
                  <button type="button" mat-icon-button class="btn-expand"
                    (click)="toggleExpandRow(row)"
                    [matTooltip]="row.expanded ? 'Masquer le détail' : 'Voir le détail des lignes et périodes'">
                    <mat-icon>{{ row.expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
                  </button>
                </td>
                <td class="col-checkbox" (click)="$event.stopPropagation()">
                  <mat-checkbox
                    [checked]="row.selected && row.excluded.size === 0"
                    [indeterminate]="row.selected && row.excluded.size > 0"
                    [disabled]="hasStarted"
                    (change)="toggleRowSelection(row)">
                  </mat-checkbox>
                </td>
                <td class="col-id font-mono">#{{ row.contract.order_id }}</td>
                <td class="col-customer font-medium">{{ row.contract.customer_name }}</td>
                <td class="col-period">
                  <!-- Synthèse globale du contrat : cumul des jours / séjours -->
                  <div class="period-summary-header">
                    @if (row.preview.has_rental_lines) {
                      <span class="summary-badge badge-days" matTooltip="Nombre de périodes (rangs) facturées sur ce contrat, toutes lignes de location confondues">
                        <mat-icon class="badge-icon">schedule</mat-icon>
                        {{ periodsLabel(getTotalPeriods(row.preview)) }}
                      </span>
                    }
                    @if (row.preview.credits.length) {
                      <span class="summary-badge badge-credit" matTooltip="Lignes d'avoir sur des factures déjà émises (trop-facturé ou vente annulée)">
                        <mat-icon class="badge-icon">undo</mat-icon>
                        <strong>{{ row.preview.credits.length }}</strong>&nbsp;ligne{{ row.preview.credits.length > 1 ? 's' : '' }} d'avoir
                      </span>
                    }
                    @if (row.contract.anomalies.length) {
                      <span class="summary-badge badge-anomaly" [class.is-blocking]="blockingAnomalies(row.contract.anomalies) > 0" matTooltip="Anomalies du calcul : une ligne bloquée n'est pas facturée (voir le détail)">
                        <mat-icon class="badge-icon">warning</mat-icon>
                        <strong>{{ row.contract.anomalies.length }}</strong>&nbsp;anomalie{{ row.contract.anomalies.length > 1 ? 's' : '' }}
                      </span>
                    }
                    @if (getRentalLinesCount(row.preview) > 1) {
                      <span class="summary-badge badge-stays" matTooltip="Nombre de séjours ou lignes de location">
                        <mat-icon class="badge-icon">groups</mat-icon>
                        <strong>{{ getRentalLinesCount(row.preview) }}</strong>&nbsp;séjours
                      </span>
                    }
                    @if (headerRange(row.preview)) {
                      <span class="summary-global-range">{{ headerRange(row.preview) }}</span>
                    }
                    @if (row.preview.has_item_lines) {
                      <span class="badge badge-item-tag" matTooltip="Articles annexes ou consommables livrés">+ Articles</span>
                    }
                  </div>
                </td>
                <td class="col-amount font-mono">
                  <!-- Sélection partielle : montants recalculés par le serveur ; le dernier reste affiché pendant le calcul -->
                  @if (row.previewLoading) {
                    <mat-progress-spinner class="amount-spinner" diameter="12" strokeWidth="2" mode="indeterminate"></mat-progress-spinner>
                  }
                  {{ money(row.preview.amount_taxi) }}&nbsp;€
                  @if (creditsTotal(row.preview) !== null && row.preview.credits.length) {
                    <div class="credit-amount" [matTooltip]="'Avoirs émis à part, en plus de la facture : ' + money(creditsTotalHt(row.preview)) + ' € HT'">avoirs {{ money(creditsTotal(row.preview)) }}&nbsp;€</div>
                  }
                  @if (row.previewError) {
                    <div class="preview-error" [title]="row.previewError">montant de la sélection indisponible</div>
                  }
                </td>
                <td class="col-type">
                  @if (row.contract.is_fse) {
                    <span class="badge badge-fse">FSE</span>
                  } @else {
                    <span class="badge badge-standard">Standard</span>
                  }
                </td>
                <td class="col-status" (click)="$event.stopPropagation()">
                  @if (row.status === 'PENDING') {
                    <span class="status-pill status-pending">
                      <mat-icon class="status-icon">schedule</mat-icon>
                      En attente
                    </span>
                  } @else if (row.status === 'PROCESSING') {
                    <span class="status-pill status-processing">
                      <mat-progress-spinner diameter="16" strokeWidth="2.5" mode="indeterminate" color="primary"></mat-progress-spinner>
                      En cours...
                    </span>
                  } @else if (row.status === 'SUCCESS') {
                    <span class="status-pill status-success">
                      <mat-icon class="status-icon">check_circle</mat-icon>
                      @if (row.fseId) {
                        FSE #{{ row.fseId }}
                      } @else {
                        Facturé
                      }
                    </span>
                  } @else if (row.status === 'UP_TO_DATE') {
                    <span class="status-pill status-uptodate" matTooltip="Le passage n'a créé ni facture ni avoir pour ce dossier : il était déjà facturé jusqu'à ce jour">
                      <mat-icon class="status-icon">task_alt</mat-icon>
                      Déjà à jour
                    </span>
                  } @else if (row.status === 'ERROR') {
                    <div class="status-error-block">
                      <span class="status-pill status-error" [matTooltip]="row.errorMessage || 'Erreur'">
                        <mat-icon class="status-icon">error</mat-icon>
                        Échec
                      </span>
                      @if (row.errorMessage) {
                        <span class="error-detail">{{ row.errorMessage }}</span>
                      }
                    </div>
                  }
                </td>
              </tr>

              <!-- Toutes les lignes sur la pleine largeur, sans hauteur fixe : le corps du dialogue défile. Montants sous « Montant TTC ». -->
              @if (!row.expanded && displayItems.length) {
                <tr class="row-lines" [ngClass]="'status-' + row.status.toLowerCase()" [class.row-unselected]="!row.selected">
                  <td colspan="8" class="lines-cell">
                    <div class="period-items-container">
                      <!-- Une ligne RENTAL peut donner plusieurs lignes de facture (fraction, report, palier) : suivi par position, jamais par ligne d'origine. -->
                      @for (item of displayItems; track $index) {
                        <div class="period-item-card" [class.is-rental]="item.isRental" [class.is-item]="!item.isRental" [class.is-excluded]="row.selected && row.excluded.has(item.id)">
                          <span class="line-check">
                            <mat-checkbox
                              [checked]="isLineChecked(row, item.id)"
                              [disabled]="hasStarted"
                              (change)="toggleLine(row, item.id)"
                              [aria-label]="'Facturer la ligne ' + (item.memo || item.title)"
                              title="Cochée : la ligne part sur la facture ; décochée : ni facturée ni créditée à ce passage">
                            </mat-checkbox>
                          </span>
                          <span class="item-memo-block">
                            @if (item.memo) {
                              <span class="patient-memo-badge" title="Patient / Séjour">{{ item.memo }}</span>
                            }
                          </span>
                          <span class="product-title">{{ item.title }}@if (item.article) {<small class="product-article">{{ item.article }}</small>}</span>
                          <span class="item-dates-block">
                            @if (item.isRental && item.start && item.end) {
                              {{ rangeLabel(item.start, item.end) }}
                            } @else {
                              <span class="badge-article-deliver">Article livré</span>
                            }
                          </span>
                          <span class="item-period-count-block">
                            @if (item.isRental) {
                              <span class="period-pill" title="Périodes (rangs) couvertes par cette ligne">{{ periodsLabel(item.periodsCount) }}</span>
                            } @else {
                              <span class="qty-pill">Qté&nbsp;<strong>{{ item.qty }}</strong></span>
                            }
                          </span>
                          <span class="item-amount-block font-mono">
                            @if (item.amountTaxi !== undefined) {
                              {{ money(item.amountTaxi) }}&nbsp;€
                            }
                          </span>
                        </div>
                      }
                    </div>
                  </td>
                </tr>
              }

              <!-- Ligne de détail dépliable : remplace la liste compacte, mêmes lignes avec type, Qté, P.U. HT et rangs -->
              @if (row.expanded) {
                <tr class="row-detail-wrapper" (click)="$event.stopPropagation()">
                  <td colspan="8" class="detail-cell">
                    <div class="detail-panel">
                      <!-- En-tête contextuel du contrat -->
                      <div class="detail-context-bar">
                        <div class="context-item">
                          <span class="context-label">1ère livraison :</span>
                          <span class="context-val">{{ day(row.contract.first_realdatdel) || '—' }}</span>
                        </div>
                        <div class="context-item">
                          <span class="context-label">Précédemment facturé jusqu'au :</span>
                          <span class="context-val">{{ billedUntilDay(row.contract) || 'Début de contrat' }}</span>
                        </div>
                        <div class="context-item">
                          <span class="context-label">Périodes antérieures réglées :</span>
                          <span class="context-val font-mono">{{ row.contract.previous_invoiced_periods || 0 }}</span>
                        </div>
                      </div>

                      <!-- Sous-tableau des lignes prévisionnelles de la facture -->
                      @if (row.contract.lines && row.contract.lines.length > 0) {
                        <div class="detail-lines-container">
                          <table class="detail-lines-table">
                            <thead>
                              <tr>
                                <th class="dt-col-check"></th>
                                <th class="dt-col-type">Type</th>
                                <th class="dt-col-product">Article / Prestation</th>
                                <th class="dt-col-periods">Période(s) / Détail unitaire</th>
                                <th class="dt-col-qty">Qté</th>
                                <th class="dt-col-uprice">P.U. HT</th>
                                <th class="dt-col-total">Total TTC</th>
                              </tr>
                            </thead>
                            <tbody>
                              @for (l of row.contract.lines; track $index) {
                                <tr class="dt-row" [class.is-excluded]="row.selected && row.excluded.has(l.origin_order_l_id)">
                                  <td class="dt-col-check line-check">
                                    <mat-checkbox
                                      [checked]="isLineChecked(row, l.origin_order_l_id)"
                                      [disabled]="hasStarted"
                                      (change)="toggleLine(row, l.origin_order_l_id)"
                                      [aria-label]="'Facturer la ligne ' + (l.memo || lineTitle(l))">
                                    </mat-checkbox>
                                  </td>
                                  <td class="dt-col-type">
                                    <span class="badge" [ngClass]="l.line_type === 'RENTAL' ? 'badge-rental-sub' : 'badge-item-sub'">
                                      {{ l.line_type === 'RENTAL' ? 'Location' : 'Article' }}
                                    </span>
                                  </td>
                                  <td class="dt-col-product font-medium">
                                    <div>{{ lineTitle(l) }}</div>
                                    @if (lineArticle(l)) {
                                      <div class="product-article">{{ lineArticle(l) }}</div>
                                    }
                                    @if (l.memo) {
                                      <div class="line-memo">{{ l.memo }}</div>
                                    }
                                  </td>
                                  <td class="dt-col-periods">
                                    @if (l.line_type === 'RENTAL') {
                                      <div class="dt-main-period font-mono">
                                        {{ periodsLabel(l.periods_count || 1) }} &bull; {{ lineRange(l) }}
                                      </div>
                                      @if (l.individual_periods && l.individual_periods.length > 1) {
                                        <div class="dt-subperiods-pills">
                                          @for (sp of l.individual_periods; track sp.rank) {
                                            <span class="dt-subperiod-chip">
                                              P{{ sp.rank }} : {{ subPeriodRange(sp) }}
                                              ({{ money(sp.uprice_taxi) }}&nbsp;€)
                                            </span>
                                          }
                                        </div>
                                      }
                                    } @else {
                                      <span class="text-muted">Article annexe livré sur BL</span>
                                    }
                                  </td>
                                  <td class="dt-col-qty font-mono">{{ l.qty }}</td>
                                  <td class="dt-col-uprice font-mono">{{ money(l.uprice_taxx) }}&nbsp;€</td>
                                  <td class="dt-col-total font-mono font-medium">
                                    {{ money(l.net_taxi) }}&nbsp;€
                                    <span class="vat-tag">({{ l.vat_rate }}%)</span>
                                  </td>
                                </tr>
                              }
                            </tbody>
                          </table>
                        </div>
                      } @else if (row.contract.periods.length) {
                        <div class="no-lines-detail">
                          <span>Détail des périodes : </span>
                          @for (p of row.contract.periods; track $index) {
                            <div class="period-badge-sub">{{ p.label }} ({{ money(p.uprice_taxi) }}&nbsp;€)</div>
                          }
                        </div>
                      }

                      <!-- Avoirs partiels : un avoir scellé par facture d'origine, lignes négatives -->
                      @if (row.contract.credits.length) {
                        <div class="detail-lines-container">
                          <div class="detail-subtitle">
                            Avoirs
                            @if (creditsTotal(row.preview) !== null) {
                              ({{ money(creditsTotal(row.preview)) }}&nbsp;€ TTC, {{ money(creditsTotalHt(row.preview)) }}&nbsp;€ HT)
                            }
                          </div>
                          <table class="detail-lines-table">
                            <thead>
                              <tr>
                                <th class="dt-col-check"></th>
                                <th class="dt-col-type">Facture corrigée</th>
                                <th class="dt-col-product">Prestation</th>
                                <th class="dt-col-periods">Période créditée</th>
                                <th class="dt-col-qty">Qté</th>
                                <th class="dt-col-uprice">P.U. HT</th>
                                <th class="dt-col-total">Total TTC</th>
                              </tr>
                            </thead>
                            <tbody>
                              @for (c of row.contract.credits; track c.corrects_line_id + '-' + c.start) {
                                <tr class="dt-row" [class.is-excluded]="row.selected && row.excluded.has(c.origin_order_l_id)" [title]="row.excluded.has(c.origin_order_l_id) ? 'Ligne décochée : avoir non posé à ce passage' : ''">
                                  <td class="dt-col-check"></td>
                                  <td class="dt-col-type font-mono">{{ c.corrects_doc_ref ?? '#' + c.corrects_invoice_id }}</td>
                                  <td class="dt-col-product font-medium">
                                    <div>{{ c.label }}</div>
                                    @if (c.memo) {
                                      <div class="line-memo">{{ c.memo }}</div>
                                    }
                                  </td>
                                  <td class="dt-col-periods font-mono" [class.is-sale-credit]="c.start == null">{{ creditRange(c) }}</td>
                                  <td class="dt-col-qty font-mono">{{ qtyFr(c.qty) }}</td>
                                  <td class="dt-col-uprice font-mono">{{ money(c.uprice_taxx) }}&nbsp;€</td>
                                  <td class="dt-col-total font-mono font-medium">
                                    {{ money(c.net_taxi) }}&nbsp;€
                                    <span class="vat-tag">({{ c.vat_rate }}%)</span>
                                  </td>
                                </tr>
                              }
                            </tbody>
                          </table>
                        </div>
                      }

                      @if (row.contract.anomalies.length) {
                        <ul class="anomaly-list">
                          @for (a of row.contract.anomalies; track $index) {
                            <li class="anomaly-item" [class.is-blocking]="a.blocked">
                              <mat-icon class="anomaly-icon">{{ a.blocked ? 'block' : 'warning' }}</mat-icon>
                              <span class="anomaly-line">{{ anomalyLine(row.contract, a) }}{{ a.blocked ? ' · bloquée, non facturée' : '' }}</span>
                              <span class="anomaly-msg">{{ a.message }}</span>
                            </li>
                          }
                        </ul>
                      }
                    </div>
                  </td>
                </tr>
              }
            }
          </tbody>
        </table>
      </div>
    } @else {
      <div class="empty-state">
        <mat-icon class="empty-icon">info</mat-icon>
        @if (asOf) {
          <p>Rien à facturer ni à créditer jusqu'au {{ day(asOf) }}.</p>
        } @else {
          <p>Aucun des contrats sélectionnés n'est actuellement échu pour la facturation.</p>
        }
      </div>
    }

    <!-- Section repliable des contrats non éligibles -->
    @if (unbillableOrders.length > 0) {
      <div class="unbillable-section">
        <button type="button" class="unbillable-toggle" (click)="toggleUnbillable()">
          <mat-icon class="toggle-icon">{{ showUnbillable ? 'expand_less' : 'expand_more' }}</mat-icon>
          <span>{{ unbillableOrders.length }} contrat{{ unbillableOrders.length > 1 ? 's' : '' }} non facturable{{ unbillableOrders.length > 1 ? 's' : '' }} (ignoré{{ unbillableOrders.length > 1 ? 's' : '' }})</span>
        </button>

        @if (showUnbillable) {
          <ul class="unbillable-list">
            @for (u of unbillableOrders; track u.order_id) {
              <li class="unbillable-item">
                <span class="unbillable-id">#{{ u.order_id }}</span>
                <span class="unbillable-name">{{ u.customer_name }}</span>
                <span class="unbillable-reason">&bull;&nbsp;{{ u.reason }}</span>
                @if (u.anomalies?.length) {
                  <ul class="anomaly-list">
                    @for (a of u.anomalies; track $index) {
                      <li class="anomaly-item" [class.is-blocking]="a.blocked">
                        <mat-icon class="anomaly-icon">{{ a.blocked ? 'block' : 'warning' }}</mat-icon>
                        <span class="anomaly-line">{{ a.origin_order_l_id == null ? 'Dossier' : 'Ligne ' + a.origin_order_l_id }}</span>
                        <span class="anomaly-msg">{{ a.message }}</span>
                      </li>
                    }
                  </ul>
                }
              </li>
            }
          </ul>
        }
      </div>
    }
  </div>

  <!-- Pied de page avec actions -->
  <div class="dialog-actions">
    <div class="actions-left">
      @if (isProcessing) {
        <span class="hint-processing">
          <mat-icon class="hint-icon">lock</mat-icon>
          Accès au lecteur CPS en cours, ne pas retirer la carte...
        </span>
      } @else if (!hasStarted) {
        <button mat-stroked-button (click)="onCancel()">
          <mat-icon>close</mat-icon>
          <span>Annuler</span>
        </button>
      }
    </div>

    <div class="actions-right">
      @if (!hasStarted) {
        @if (rows.length > 0) {
          <button
            mat-flat-button
            color="primary"
            (click)="startInvoicingProcess()"
            [disabled]="selectedCount === 0 || previewPending || checking">
            @if (checking) { <mat-progress-spinner diameter="16" strokeWidth="2.5" mode="indeterminate"></mat-progress-spinner> } @else { <mat-icon>receipt_long</mat-icon> }
            <span>@if (checking) { Vérification de l'aperçu… } @else { Confirmer la facturation ({{ selectedCount }}) }</span>
          </button>
        } @else {
          <button mat-flat-button color="primary" (click)="onClose()">
            <mat-icon>done</mat-icon>
            <span>Fermer</span>
          </button>
        }
      } @else if (isFinished) {
        <button
          mat-flat-button
          color="primary"
          (click)="onClose()">
          <mat-icon>done</mat-icon>
          <span>Fermer</span>
        </button>
      } @else if (isProcessing) {
        <button mat-flat-button color="primary" [disabled]="true">
          <mat-progress-spinner diameter="16" strokeWidth="2.5" mode="indeterminate" color="primary"></mat-progress-spinner>
          <span>Facturation en cours...</span>
        </button>
      }
    </div>
  </div>

</div>
